<app-example-wrapper-seamless sectionHeading="Team Members">
    <!-- <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-3">
                <div class="no-gutters row">
                    <div class="col-md-3 p-3">
                        <a [routerLink]="" class="">
                            <div class="divider-v divider-v-lg"></div>
                            <div class="row">
                                <div class="col">
                                    <div class="text-center">
                                        <div class="line-height-sm">
                                            <b class="font-size-lg">12</b>
                                            <a class="text-success d-block">Active Concierges</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-3 p-3" >
                        <a [routerLink]="" class="">
                            <div class="divider-v divider-v-lg"></div>
                            <div class="row">
                                <div class="col">
                                    <div class="text-center">
                                        <div class="line-height-sm">
                                            <b class="font-size-lg">13</b>
                                            <a class="text-warning d-block">Inactive Concierges</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-3 p-3" >
                        <a [routerLink]="" class="">
                            <div class="row">
                                <div class="col">
                                    <div class="text-center">
                                        <div class="line-height-sm">
                                            <b class="font-size-lg">14</b>
                                            <a class="text-success d-block">Active Station Managers</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-3 p-3" >
                        <a [routerLink]="" class="">
                            <div class="row">
                                <div class="col">
                                    <div class="text-center">
                                        <div class="line-height-sm">
                                            <b class="font-size-lg">14</b>
                                            <a class="text-warning d-block">Inactive Station Managers</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-5">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" placeholder="Search..."
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addEmployee()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Team Member
                                </span>
                            </button>
                            <button (click)="getData()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="allEmployees | tsearch:searchText; let filteredEmployees">
                        <div class="table-responsive table-scroll">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                [mfData]="filteredEmployees" #mf="mfDataTable" [mfRowsOnPage]="100"
                                [mfActivePage]="activePage">
                                <thead>
                                    <tr>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="emp_id">ID</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white">
                                            <mfDefaultSorter by="firstname">Name</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">Phone No</th>
                                        <th class="bg-white text-left">Email</th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="role">Role</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="role">Source</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="stations">Station</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">Available Slots</th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="active">Status</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let employee of mf.data ; let i=index">
                                        <td class="font-weight-bold">
                                            <a [routerLink]="['/home/edit-employee', employee.id]"
                                                class="font-weight-bold text-black" title="...">
                                                {{employee.emp_id}}
                                            </a>
                                        </td>
                                        <td class="text-left">
                                            {{employee.firstname}} {{employee.lastname}}
                                        </td>
                                        <td class="text-left ">
                                            {{employee.mobileno}}
                                        </td>
                                        <td class="text-left ">
                                            {{employee.email}} </td>
                                        <td class="text-left ">
                                            {{employee.role}}
                                        </td>
                                        <td class="text-left ">
                                            {{employee.source}}
                                        </td>
                                        <td class="text-left ">
                                            {{employee.stations}}
                                        </td>
                                        <td>
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="View Slots"
                                                type="button" *ngIf="employee.access_level!=2"
                                                (click)="getAvailableSlots(employee)">View
                                            </button>
                                        </td>
                                        <td class="text-left ">
                                            <span class="badge bg-neutral-dark text-success"
                                                *ngIf="employee.active==true">Active</span>
                                            <span class="badge bg-neutral-dark text-warning"
                                                *ngIf="employee.active==false">Inactive</span>
                                        </td>
                                        <td class="text-left">
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="Edit" type="button"
                                                (click)="editEmployee(employee)">
                                                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="12">
                                            <span class="font-weight-bold text-primary">Total Team Members:
                                                {{filteredEmployees.length}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-success">Active :
                                                {{calculateActiveEmployees(filteredEmployees)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-warning">Inactive :
                                                {{calculateInActiveEmployees(filteredEmployees)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <mfBootstrapPaginator [rowsOnPageSet]="[100,200]">jjjj
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>